import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import SensorThChart from "../components/SensorThChart";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const SensorThChartPage = () => {
    const { t } = useTranslation("global");
    const { auth } = useAuth();
    const { sensorId } = useParams();
    const [sensorData, setSensorData] = useState([]);
    const [period, setPeriod] = useState('day'); // day, week, month, year
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Formato YYYY-MM-DD
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        if (!auth?.accessToken) {
            return;
        }
        
        // Recupera i dati del sensore in base ai filtri
        const fetchSensorData = async () => {
            try {
                const response = await axiosPrivate.get(`/sensors/${sensorId}/daily`, {
                    params: {
                        period: period,
                        date: selectedDate
                    }
                });
                setSensorData(response.data);
            } catch (error) {
                console.error(t('sensors.errors.dataFetch', "Errore nel recupero dei dati del sensore:"), error);
            }
        };

        fetchSensorData();
    }, [sensorId, period, selectedDate, t, axiosPrivate, auth?.accessToken]);

    const handlePeriodChange = (newPeriod) => {
        setPeriod(newPeriod);
    };

    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                {t('sensors.chart.pageTitle', "Grafico Sensore {{id}}", { id: sensorId })}
            </Typography>
            <Box sx={{ mt: 2 }}>
                <SensorThChart 
                    sensorId={sensorId} 
                    data={sensorData}
                    period={period}
                    onPeriodChange={handlePeriodChange}
                    selectedDate={selectedDate}
                    onDateChange={handleDateChange}
                />
            </Box>
        </Box>
    );
};

export default SensorThChartPage;